// ═══════════════════════════════════════════════════════════════
// AGENCIAS · Vista de lanzamiento — la pantalla (view.js)
// Lo que ve quien aún no puede entrar en Agencias: el anuncio de TikControl
// Agencies con su fecha, qué traerá (tarjetas) y «Agenda tu llamada».
//
// Al entrar se anima de corrido (data-step en .agl marca por dónde va):
//   0  solo el fondo
//   1  entran despacio las dos pantallas de los lados (Analítica y Creadores),
//      cada una desde su lado, y se quedan ya en su sitio
//   2  el bloque principal: «Lanzamiento oficial», el logo y la fecha, grande
//      y centrado
//   3… los dos textos, las tarjetas (fila a fila, de una en una) y el bloque
//      de la llamada, cada uno saliendo antes de que acabe el anterior
// Ya asentada, cada tarjeta se gira con el ratón encima y enseña su dorso
// (un texto más largo); eso es solo CSS.
// Desde el paso 3 la columna sube y el logo encoge en UN solo movimiento
// (--agl-shift y --agl-head-scale, durante --agl-glide). Recolocarla con cada
// bloque se veía a saltos: cada parada y arranque se nota.
// Un clic salta la animación; con «reducir movimiento» no la hay.
//
// Es la MISMA pieza en la app y en la vista previa del backoffice (que la
// importa tal cual junto con styles/views/agency-launch.css): solo pinta lo
// que le da content.js › resolve(). No pide datos ni conoce al usuario.
// Expone window.AgenciasLaunchView = { html, mount, panels }.
// TikControl © 2024-2026
// ═══════════════════════════════════════════════════════════════

(function (root) {
  'use strict';

  var Icons = function () { return root.AgenciasLaunchIcons; };

  var DEFAULT_LOGO = './assets/icons/menu/tikcontrol-agencies-imagotipo.svg';

  // Tiempos de la entrada (ms). Todo se solapa: nada espera a que acabe lo
  // anterior. Lo que dura cada movimiento está en agency-launch.css.
  var MOCKS_AT = 150;       // empiezan a entrar las pantallas de los lados (~1,5 s)
  var HEAD_AT = 1650;       // sale el bloque principal, con las pantallas ya en su sitio
  var HEAD_ALONE = 1000;    // lo que el bloque principal se queda solo en el centro
  var STAGGER = 460;        // de un bloque al siguiente
  var GLIDE_TAIL = 1000;    // lo que la columna sigue subiendo tras salir el último
  var SETTLE_MS = 1700;     // lo que tarda en asentarse el último bloque
  var SKIP_MS = 500;        // saltada con un clic: lo que tarda en colocarse todo
  var HEAD_SCALE = 1.32;    // el logo sale grande mientras está solo

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var SVG = {
    calendar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4.5" width="18" height="16.5" rx="2.5"/><path d="M3 9.5h18M8 2.5v4M16 2.5v4"/><path d="M7.5 13.5h2M11 13.5h2M14.5 13.5h2M7.5 17h2M11 17h2"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h16M14 6l6 6-6 6"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M7.5 12.3l3 3 6-6.3"/></svg>',
    diamond: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><path d="M6 4h12l4 5.5L12 21 2 9.5 6 4zM2 9.5h20M9 4l-2 5.5L12 21l5-11.5L15 4"/></svg>',
    swords: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 17.5 3 6V3h3l11.5 11.5M13 19l6-6M16 16l4 4M9.5 17.5 3.5 20.5M14.5 6.5 18 3h3v3l-3.5 3.5"/></svg>',
    users: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="8" r="3.5"/><path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 4.8a3.5 3.5 0 0 1 0 6.4M18 14.5a6.5 6.5 0 0 1 3.5 5.5"/></svg>',
    bonus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2.5"/><path d="M12 8v8M9.5 10.5 12 8l2.5 2.5"/></svg>',
    star: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><path d="m12 3 2.7 5.6 6.1.8-4.5 4.3 1.1 6.1L12 16.9 6.6 19.8l1.1-6.1L3.2 9.4l6.1-.8L12 3z"/></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.8-3.8"/></svg>',
    filter: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5h18l-7 8.5V19l-4 2v-7.5L3 5z"/></svg>'
  };

  // ── Las dos pantallas de los lados (decorado: datos de muestra) ──
  function kpi(icon, tone, label, value, foot) {
    return '<div class="agl-p-kpi">' +
      '<span class="agl-p-kpi-ic agl-tone--' + tone + '">' + SVG[icon] + '</span>' +
      '<span class="agl-p-kpi-label">' + esc(label) + '</span>' +
      '<strong class="agl-p-kpi-value">' + esc(value) + '</strong>' +
      '<span class="agl-p-kpi-foot">' + foot + '</span>' +
    '</div>';
  }

  function trend(pct, text) {
    var up = pct >= 0;
    return '<b class="' + (up ? 'is-up' : 'is-down') + '">' + (up ? '↑' : '↓') + ' ' + Math.abs(pct) + '%</b>' + (text ? ' ' + esc(text) : '');
  }

  var CHART_LINE = 'M52 172 64 165 76 168 88 158 100 163 112 170 124 174 136 166 148 160 160 169 172 176 184 170 196 162 208 168 220 175 232 169 244 158 256 166 268 173 280 168 292 160 304 167 316 174 328 178 340 172 352 176 364 179 376 175 388 181 400 172 410 150 420 112 430 96';
  // La gráfica baja (anuncio del Inicio): menos alto y la línea, repartida por él.
  var CHART_LINE_LOW = 'M52 96 66 91 80 94 94 86 108 89 122 80 136 84 150 74 164 78 178 69 192 73 206 62 220 67 234 58 248 63 262 52 276 57 290 47 304 52 318 42 332 47 346 38 360 43 374 33 388 37 402 28 416 31 430 20';

  function chart(low) {
    var rows = low ? [['2M', 16], ['1M', 61], ['0', 106]] : [['2M', 30], ['1.5M', 70], ['1M', 110], ['500K', 150], ['0', 190]];
    var base = rows[rows.length - 1][1];
    var line = low ? CHART_LINE_LOW : CHART_LINE;
    var grid = rows.map(function (r) {
      return '<text x="34" y="' + (r[1] + 4) + '" text-anchor="end">' + r[0] + '</text><path class="agl-p-grid" d="M46 ' + r[1] + 'H436"/>';
    }).join('');
    var days = [[1, 60], [8, 152], [15, 244], [22, 336], [29, 428]].map(function (d) {
      return '<text x="' + d[1] + '" y="' + (base + 22) + '" text-anchor="middle">' + d[0] + '</text>';
    }).join('');
    return '<svg class="agl-p-chart" viewBox="0 0 440 ' + (base + 30) + '" preserveAspectRatio="none" aria-hidden="true">' + grid + days +
      '<path class="agl-p-area" d="' + line + ' V' + base + ' H52Z"/>' +
      '<path class="agl-p-line" d="' + line + '"/>' +
    '</svg>';
  }

  function analyticsPanel(t, num, low) {
    var vs = t('agencies_an_vs_prev_month', 'vs. mes anterior');
    return '<div class="agl-panel">' +
      '<h4 class="agl-p-title">' + esc(t('agencies_nav_analytics', 'Analítica')) + '</h4>' +
      '<p class="agl-p-sub">' + esc(t('agencies_an_subtitle', 'Visión global de tu agencia. Analiza el rendimiento, detecta oportunidades y toma mejores decisiones.')) + '</p>' +
      '<div class="agl-p-kpis">' +
        kpi('diamond', 'blue', t('agencies_an_kpi_diamonds', 'Diamantes totales'), num(12828881), trend(9, vs)) +
        kpi('swords', 'purple', t('agencies_an_kpi_battles', 'Diamantes en batallas'), num(6341538), trend(23)) +
        kpi('diamond', 'pink', t('agencies_an_kpi_outside', 'Diamantes fuera de batallas'), num(6487343), trend(-2)) +
      '</div>' +
      '<div class="agl-p-box">' +
        '<h5>' + esc(t('agencies_an_evo_title', 'Evolución de la agencia')) + '</h5>' +
        '<p>' + esc(t('agencies_an_evo_sub_diamonds', 'Diamantes generados cada día y comparativa con el mes anterior.')) + '</p>' +
        chart(low) +
      '</div>' +
    '</div>';
  }

  var CREATORS = [
    ['streamer_01', 7, '#f59e0b', '1.3M'], ['livequeen', 4, '#ec4899', '619.9K'],
    ['creator_es', 5, '#22c55e', '402.5K'], ['nightshow', 3, '#8b5cf6', '268.1K']
  ];

  function creatorsPanel(t, num, rowCount) {
    var ofTotal = t('agencies_of_total', 'del total');
    var level = t('community_col_level', 'Nivel');
    var projection = t('agencies_rs_projection_day', 'Proyección · Día {d}/{n}').replace('{d}', '6').replace('{n}', '31');
    var chip = function (label, n, on) {
      return '<span class="agl-p-chip' + (on ? ' is-on' : '') + '">' + esc(label) + '<i>' + n + '</i></span>';
    };
    var rows = CREATORS.slice(0, rowCount || CREATORS.length).map(function (c) {
      return '<div class="agl-p-row">' +
        '<span class="agl-p-who"><i class="agl-p-avatar" style="background:' + c[2] + '">' + c[0].charAt(0).toUpperCase() + '</i>' +
          '<span>@' + c[0] + '<em>' + esc(level) + ' ' + c[1] + '</em></span></span>' +
        '<span class="agl-p-status">' +
          '<span>' + SVG.star + esc(t('agencies_rank_retention', 'Retención de rango')) + '</span>' +
          '<span>' + SVG.star + esc(t('agencies_rank_up', 'Subida de rango')) + '</span>' +
        '</span>' +
        '<span class="agl-p-proj"><em>' + esc(projection) + '</em><strong>' + c[3] + SVG.diamond + '</strong></span>' +
      '</div>';
    }).join('');
    return '<div class="agl-panel">' +
      '<h4 class="agl-p-title">' + esc(t('agencies_tab_creators', 'Creadores')) + '</h4>' +
      '<p class="agl-p-sub">' + esc(t('agencies_creators_sub', 'Gestiona tu cartera y maximiza la monetización de tus creadores.')) + '</p>' +
      '<div class="agl-p-kpis">' +
        kpi('users', 'blue', t('agencies_total_creators', 'Creadores totales'), num(897), '100% ' + esc(ofTotal)) +
        kpi('bonus', 'green', t('agencies_in_bonus', 'En bonus'), '0', '0% ' + esc(ofTotal)) +
        kpi('star', 'purple', t('agencies_level_candidates', 'Candidatos a subir nivel'), '27', '3% ' + esc(ofTotal)) +
      '</div>' +
      '<div class="agl-p-tools">' +
        '<span class="agl-p-search">' + SVG.search + esc(t('agencies_search_creator', 'Buscar creador...')) + '</span>' +
        '<span class="agl-p-btn">' + esc(t('agencies_rise_incentive', 'Incentivo de subida')) + '</span>' +
        '<span class="agl-p-btn">' + SVG.filter + esc(t('agencies_more_filters', 'Más filtros')) + '</span>' +
      '</div>' +
      '<div class="agl-p-chips">' +
        chip(t('actions_all', 'Todos'), 897, true) +
        chip(t('agencies_qf_en-directo', 'En directo'), 16) +
        chip(t('agencies_qf_en-bonus', 'En bonus'), 0) +
        chip(t('agencies_atag_riesgo', 'Riesgo de bonus'), 897) +
      '</div>' +
      '<div class="agl-p-table">' + rows + '</div>' +
    '</div>';
  }

  // ── La pantalla ──────────────────────────────────────────────
  // Una tarjeta: su cara (icono, título, texto) y, si tiene dorso, la otra cara
  // con el texto largo, que sale al girarla con el ratón encima (o con el foco).
  function cardHtml(card, i) {
    var front = '<div class="agl-card-face agl-card-front">' +
      Icons().svg(card.icon, 'agl-card-ic') +
      '<h3 class="agl-card-title" dir="auto">' + esc(card.title) + '</h3>' +
      (card.text ? '<p class="agl-card-text" dir="auto">' + esc(card.text) + '</p>' : '') +
    '</div>';
    if (!card.back) {
      return '<article class="agl-card" style="--i:' + i + '"><div class="agl-card-in">' + front + '</div></article>';
    }
    return '<article class="agl-card has-back" tabindex="0" style="--i:' + i + '"><div class="agl-card-in">' +
      front +
      '<div class="agl-card-face agl-card-back">' +
        '<p class="agl-card-back-title" dir="auto" aria-hidden="true">' + esc(card.title) + '</p>' +
        '<p class="agl-card-back-text" dir="auto">' + esc(card.back) + '</p>' +
      '</div>' +
    '</div></article>';
  }

  function ctaHtml(cta) {
    return '<section class="agl-sec agl-cta" data-agl-sec="cta">' +
      (cta.kicker ? '<p class="agl-cta-kicker" dir="auto">' + esc(cta.kicker) + '</p>' : '') +
      '<h2 class="agl-cta-title" dir="auto">' + esc(cta.title) + '</h2>' +
      (cta.text ? '<p class="agl-cta-text" dir="auto">' + esc(cta.text) + '</p>' : '') +
      '<button type="button" class="agl-cta-btn" data-agl-cta>' + SVG.calendar + '<span dir="auto">' + esc(cta.button) + '</span>' + SVG.arrow + '</button>' +
      '<ul class="agl-checks">' + cta.checks.filter(Boolean).map(function (c) {
        return '<li>' + SVG.check + '<span dir="auto">' + esc(c) + '</span></li>';
      }).join('') + '</ul>' +
    '</section>';
  }

  // Con qué se escriben los textos y los números de las pantallas de los lados.
  function writers(opts) {
    var lang = String(opts.lang || 'es').slice(0, 2);
    return {
      lang: lang,
      t: typeof opts.t === 'function' ? opts.t : function (_key, fallback) { return fallback; },
      num: function (n) {
        try { return Number(n).toLocaleString(lang); } catch (_) { return String(n); }
      }
    };
  }

  /**
   * Las dos pantallas de los lados, sueltas: el anuncio del Inicio las pone a
   * los lados de su bloque (tabs/inicio/componentes/agencia.js), más bajas que
   * aquí (la gráfica baja y dos creadores en la tabla).
   * opts: { t(key, porDefecto), lang }. Devuelve { analytics, creators }.
   */
  function panels(opts) {
    var w = writers(opts || {});
    return { analytics: analyticsPanel(w.t, w.num, true), creators: creatorsPanel(w.t, w.num, 2) };
  }

  /**
   * Marcado de la pantalla. `model` = AgenciasLaunchContent.resolve(...).
   * opts: { t(key, porDefecto), lang, logoUrl }.
   */
  function html(model, opts) {
    opts = opts || {};
    var w = writers(opts);
    var t = w.t;
    var lang = w.lang;
    var num = w.num;
    var rows = (model.rows || []).map(function (row, r) {
      // La fila con menos tarjetas que la primera va un poco metida, como en el diseño.
      var inset = r > 0 && row.length < model.rows[0].length ? ' agl-row--inset' : '';
      return '<div class="agl-sec agl-row' + inset + '" data-agl-sec="row" style="--n:' + row.length + '">' + row.map(cardHtml).join('') + '</div>';
    }).join('');

    // `lang` en la raíz: el CSS quita el espaciado entre letras en las escrituras enlazadas.
    return '<div class="agl" lang="' + esc(lang) + '" data-step="0" data-mocks="out">' +
      '<div class="agl-bg" aria-hidden="true"></div>' +
      '<div class="agl-mock agl-mock--left" aria-hidden="true">' + analyticsPanel(t, num) + '</div>' +
      '<div class="agl-mock agl-mock--right" aria-hidden="true">' + creatorsPanel(t, num) + '</div>' +
      '<div class="agl-stage"><div class="agl-col">' +
        '<header class="agl-sec agl-head" data-agl-sec="head"><div class="agl-head-in">' +
          (model.badge ? '<span class="agl-badge" dir="auto">' + esc(model.badge) + '</span>' : '') +
          '<img class="agl-logo" src="' + esc(opts.logoUrl || DEFAULT_LOGO) + '" alt="TikControl Agencies" draggable="false">' +
          (model.date ? '<p class="agl-date" dir="auto">' + esc(model.date) + '</p>' : '') +
        '</div></header>' +
        (model.headline || model.subhead
          ? '<div class="agl-sec agl-copy" data-agl-sec="copy">' +
              (model.headline ? '<h1 class="agl-headline" dir="auto">' + esc(model.headline) + '</h1>' : '') +
              (model.subhead ? '<p class="agl-subhead" dir="auto">' + esc(model.subhead) + '</p>' : '') +
            '</div>'
          : '') +
        (rows ? '<div class="agl-cards">' + rows + '</div>' : '') +
        (model.cta ? ctaHtml(model.cta) : '') +
      '</div></div>' +
    '</div>';
  }

  /**
   * Pinta la pantalla en `host` y, con `intro`, la anima al entrar.
   * opts: las de html() + { intro, onCta }.
   * Devuelve { el, finish(), destroy() }.
   */
  function mount(host, model, opts) {
    opts = opts || {};
    host.innerHTML = html(model, opts);
    var el = host.firstElementChild;
    var col = el.querySelector('.agl-col');
    var head = el.querySelector('.agl-head');
    var secs = Array.prototype.slice.call(el.querySelectorAll('[data-agl-sec]'));
    var timers = [];
    var alone = true;       // el bloque principal aún está solo (grande y centrado)
    var done = false;
    var observer = null;

    function later(ms, fn) { timers.push(setTimeout(fn, ms)); }

    // Dónde está la columna: con el bloque principal solo, bajada hasta dejarlo
    // centrado (y grande); después, en su sitio.
    function place() {
      var shift = 0;
      var scale = 1;
      if (alone) {
        scale = HEAD_SCALE;
        shift = (col.offsetHeight - (head.offsetTop + head.offsetHeight)) / 2 + (scale - 1) * head.offsetHeight / 2;
      }
      col.style.setProperty('--agl-shift', Math.max(0, Math.round(shift)) + 'px');
      head.style.setProperty('--agl-head-scale', String(scale));
    }

    function show(i) {
      secs[i].classList.add('is-in');
      el.dataset.step = String(i + 2);
    }

    // La columna deja de estar sujeta y va a su sitio (lo que dure --agl-glide).
    function release() {
      alone = false;
      el.classList.remove('agl--hold');
      void col.offsetWidth;   // que el cambio de abajo se anime desde donde está
      place();
    }

    // Asentado: desde aquí nada se mueve solo.
    function settle() {
      done = true;
      el.classList.add('agl--done');
    }

    function finish() {
      timers.forEach(clearTimeout);
      timers = [];
      secs.forEach(function (sec) { sec.classList.add('is-in'); });
      el.dataset.step = String(secs.length + 1);
      el.dataset.mocks = 'in';
      release();
      settle();
    }

    function destroy() {
      timers.forEach(clearTimeout);
      timers = [];
      if (observer) { observer.disconnect(); observer = null; }
    }

    var cta = el.querySelector('[data-agl-cta]');
    if (cta && typeof opts.onCta === 'function') cta.addEventListener('click', function () { opts.onCta(); });

    var reduced = false;
    try { reduced = !!(root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (_) { reduced = false; }

    if (!opts.intro || reduced) {
      el.classList.add('agl--static');
      finish();
      return { el: el, finish: finish, destroy: destroy };
    }

    // La columna espera, sujeta (sin animarse), donde saldrá el logo.
    el.classList.add('agl--hold');
    place();
    later(MOCKS_AT, function () { el.dataset.step = '1'; el.dataset.mocks = 'in'; });
    later(HEAD_AT, function () { show(0); });
    // El resto sale de corrido mientras la columna sube en un solo movimiento,
    // que acaba poco después de salir el último bloque.
    var unfoldAt = HEAD_AT + HEAD_ALONE;
    var lastAt = unfoldAt + Math.max(0, secs.length - 2) * STAGGER;
    later(unfoldAt, function () {
      el.style.setProperty('--agl-glide', (lastAt - unfoldAt + GLIDE_TAIL) + 'ms');
      release();
    });
    secs.forEach(function (_sec, i) {
      if (i > 0) later(unfoldAt + (i - 1) * STAGGER, function () { show(i); });
    });
    later(lastAt + SETTLE_MS, settle);

    // Un clic en cualquier sitio la salta: todo va a su sitio enseguida.
    el.addEventListener('pointerdown', function () {
      if (done) return;
      el.classList.add('agl--skip');
      finish();
      setTimeout(function () { el.classList.remove('agl--skip'); }, SKIP_MS + 100);
    }, { once: true });
    // Si cambia el tamaño mientras el bloque principal está solo, se recoloca.
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(function () { if (alone) place(); });
      observer.observe(el);
    }
    return { el: el, finish: finish, destroy: destroy };
  }

  var api = { html: html, mount: mount, panels: panels };
  root.AgenciasLaunchView = api;
  if (typeof module === 'object' && module && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
